import React from "react";
import { Layout, Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import {
	SIDE_NAV_WIDTH,
	SIDE_NAV_DARK,
	NAV_TYPE_SIDE,
} from "constants/ThemeConstant";
import { PUBLIC_PREFIX_PATH } from "configs/AppConfig";
import { Scrollbars } from "react-custom-scrollbars";
import MenuContent from "./MenuContent";
import { signOut } from "redux/actions/Auth";

const LOGO_SRC = `${PUBLIC_PREFIX_PATH}/novo_design/SITE-CARBON-SMART-2026/PNG_s/Logo-CarbonSmart-P-09-header.png`;
const { Sider } = Layout;

export const SideNav = ({
	navCollapsed,
	sideNavTheme,
	routeInfo,
	hideGroupTitle,
	localization = true,
	signOut: onSignOut,
}) => {
	const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };
	return (
		<Sider
			className={`side-nav ${
				sideNavTheme === SIDE_NAV_DARK ? "side-nav-dark" : ""
			}`}
			width={SIDE_NAV_WIDTH}
			collapsed={navCollapsed}
			style={{
				backgroundColor: "#0F251D",
				height: "100vh",
				position: "fixed",
				top: 0,
				left: 0,
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					height: "100vh",
					minHeight: 0,
				}}
			>
				{/* Logo no topo do menu */}
				<div
					style={{
						padding: "16px",
						display: "flex",
						alignItems: "center",
						justifyContent: navCollapsed ? "center" : "flex-start",
						borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
						flexShrink: 0,
					}}
				>
					<img
						src={LOGO_SRC}
						alt="CarbonSmart"
						style={{
							height: navCollapsed ? 36 : 48,
							width: "auto",
							maxWidth: navCollapsed ? 48 : "100%",
							objectFit: "contain",
							objectPosition: "left center",
							display: "block",
						}}
					/>
				</div>
				{/* Área rolável com itens do menu */}
				<div
					style={{
						flex: 1,
						minHeight: 0,
						overflow: "hidden",
					}}
				>
					<Scrollbars autoHide style={{ height: "100%" }}>
						<MenuContent type={NAV_TYPE_SIDE} {...props} />
					</Scrollbars>
				</div>
				{/* Botão Sair fixo no final */}
				<div
					style={{
						flexShrink: 0,
						padding: "12px 16px",
						borderTop: "1px solid rgba(255, 255, 255, 0.1)",
					}}
				>
					<Button
						type="text"
						icon={<LogoutOutlined />}
						onClick={onSignOut}
						block
						style={{
							color: "rgba(255, 255, 255, 0.85)",
							textAlign: navCollapsed ? "center" : "left",
							height: 40,
						}}
					>
						{!navCollapsed && "Sair"}
					</Button>
				</div>
			</div>
		</Sider>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, sideNavTheme } = theme;
	return { navCollapsed, sideNavTheme };
};

export default connect(mapStateToProps, { signOut })(SideNav);
